import { FlagAE, FlagGB } from "@repo/assets/images";

export const ORIGIN_TO_FLAG_MAP = {
  "staging-web.alhome.com": "staging",
  "localhost:3000": "staging",
  "shop.alhome.com": "production",
  "ruksa.olltek.com": "ruksa",
  "shop.polluxa.com": "ruksa",
  "wooden-street.polluxa.com": "ruksa",
};

export const ORIGIN_TO_SLUG_MAP = {
  "staging-web.alhome.com": "alhome-web-home",
  "localhost:3000": "alhome-web-home",
  "shop.alhome.com": "alhome-web-home",
  "moroccoglobal.olltek.com": "morocco-global",
  "ruksa.olltek.com": "ruksa",
  "shop.polluxa.com": "wooden-street",
  "wooden-street.polluxa.com": "wooden-street",
};

export const defaultMetaData = {
  title:
    "Get Top Furniture and Appliances at Alhome.com, Upgrade Your Home Now! &ndash; ALHOME",
  description:
    "Transform your living space with Alhome.com&#39;s range of stylish furniture and appliances. Huge selection, fast shipping, and best prices, Shop Now!",
};

export const commonOpenGraphMeta = {
  url: "./",
  siteName: "ALHOME",
  type: "website",
};

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN", icon: <FlagGB /> },
  { code: "ar", label: "العربية", short: "AR", icon: <FlagAE /> },
];

export const headerLogoPosition = "center";
